module.exports = __webpack_public_path__ + "img/Montserrat.a636d0dd.svg";